"use strict";
var burger = document.querySelector(".icon--menu");
var handClose = document.querySelector(".icon--close");
var menu = document.querySelector(".menu");
burger.addEventListener("click", function() {
    menu.classList.add("active");
    document.body.classList.add("disable-scroll");
});
handClose.addEventListener("click", function() {
    menu.classList.remove("active");
    document.body.classList.remove("disable-scroll");
});
document.querySelector(".contact__form").addEventListener("submit", function(e) {
    if (!this.checkValidity()) return;
    e.preventDefault();
    alert("Form successfully submitted!");
    this.reset();
});

//# sourceMappingURL=index.99252e4e.js.map
